// removed by extract-text-webpack-plugin
module.exports = {"contents":"ArenaTooltip_contents--UhaN2","title":"ArenaTooltip_title--3UIzQ","details":"ArenaTooltip_details--1SSK-","caption":"ArenaTooltip_caption--2AJzx","minimap":"ArenaTooltip_minimap--M9757","minimapEmblem":"ArenaTooltip_minimapEmblem--4xVwg"};


//////////////////
// WEBPACK FOOTER
// ./components/ArenaTooltip/ArenaTooltip.scss
// module id = 230
// module chunks = 11 12 14